import qsParse from 'qs/lib/parse';

export default qsParse(window.location.search.replace('?', ''));
